import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { redirectCoupon } from "../Apis";
import { couponFrm } from "../Assets/Images";
import html2canvas from "html2canvas";

const RedirectCoupon = () => {
  const [couponvalue, setCouponvalue] = useState<any>({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qrValue = queryParams.get("qr");
  const couponRef = useRef<any>(null);

  const getCoupon = async () => {
    const params = { coupon_code: qrValue };
    await redirectCoupon(params)
      .then((res: any) => {
        setCouponvalue(res);
        setTimeout(() => {
          generateImage();
        }, 100);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // useEffect(() => {
  //   getCoupon();
  // }, []);

  useEffect(() => {
    RedirectUrl();
  }, []);

  const RedirectUrl = () => {
    const fallbackUrl = `${process.env.REACT_APP_COUPON_REDIRECT_URL}/redeem/${qrValue}`;

    const userAgent = navigator.userAgent;

    const isMobileUA =
      /android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(userAgent);

    const isMobile = isMobileUA;

    if (isMobile) {
      setTimeout(() => {
        window.location.replace(fallbackUrl);
      }, 100);
    } else {
      getCoupon();
    }
  };

  const points = couponvalue?.data?.amount || 0;

  const [imageSrc, setImageSrc] = useState<string | null>(null);

  const generateImage = async () => {
    if (!couponRef.current) return;

    const canvas = await html2canvas(couponRef.current, {
      scale: 3,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");
    setImageSrc(imgData);
  };

  return (
    <>
    {imageSrc ? (
      <div className="d-flex justify-content-center" >
        <img
          src={imageSrc}
          alt="Coupon"
          style={{
            // width: "100%",
            aspectRatio: "600 / 900",
            height: "100vh",
            maxHeight: "100vw"
          }}
        />
      </div>
    ) : (
    <div style={{ opacity: "0", }}>
      <div className="d-flex justify-content-center">
      <div ref={couponRef}>
        <div 
          style={{
            position: "relative",
            // height: "100vh",
            aspectRatio: "600 / 900",
            maxWidth: "80.9vh",
            width: "100vw",
            // backgroundImage: `url(${couponFrm})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <img src={couponFrm} 
            alt="Coupon Frame"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
          <div className="cpn-show">
            {couponvalue?.data?.qr ? (
              <>
                <img
                  src={couponvalue.data.qr}
                  alt="QR"
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
              </>
            ) : (
              <h4 className="mt-5 mb-5 text-center">{couponvalue?.message}</h4>
            )}
          </div>
          <h1
            className={`cpn-amt ${points > 99 ? "cpn-amt-lg" : ""}`}
            style={{
              left: points > 99 ? "44.8%" : "44%",
              top: points > 99 ? "87.2%" : "87.2%",
              fontSize: points > 99 ? "1.9vw" : "1.4vw",
            }}
          >
            {points}
          </h1>
          <p className="cpn-code">{qrValue}</p>
        </div>
      </div>
      </div>
    </div>
    )}
    </>
  );
};

export default RedirectCoupon;
